<template>
  <div class="NewsDetails">
    <banner img="../assets/img/bgtop.jpg" title="案例详情"/>
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <el-row class="business-msg">
          <el-col :span="11">
            <img class="msg-img" :src="cases.fileUrls[0]" :alt="cases.title" style="width: 90%;box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.2);">
          </el-col>
          <el-col :span="12">
            <h1 style="text-align: left">{{ cases.title }}</h1>
            <div class="button" style="margin-top:2vw">
              <el-button type="primary" @click="contactNow" round>免费回电</el-button>
              <el-button type="success" @click="showCompanyInfo" round>立即联系</el-button>
            </div>
          </el-col>
        </el-row>

        <div class="slip-text">
            <div class="slip">
              <span class="slip-detail">业务介绍</span>
            </div>
            <div class="text-content" v-html="cases.description">
            </div>
          </div>
        <el-carousel class="img">
          <el-carousel-item v-for="item in cases.fileUrls" :key="item">
            <img :src="item" alt  style="object-fit: contain;"/>
          </el-carousel-item>
        </el-carousel>
        <p class="product-title">{{cases.title}}</p>
        <div class="product-content" v-html="cases.content"></div>
      </div>

      <div class="arrow-container" @click="scrollDown">
            <span class="label">相关推荐</span>
            <div class="arrow"></div>
      </div>

      <div class="content-modular-item">
          <div
            class="item-list"
            v-for="(item, index) in caseList"
            :key="index"
          >
            <div class="item-img" @click="routeLink(item.id)" v-lazy:background-image="item.fileUrls"></div>
            <p class="item-list-title" @click="routeLink(item.id)">{{ item.title }}</p>
          </div>
       </div>
    </div>
    <ContactUs ref="contactUs"></ContactUs>
    <CompanyInfo ref="companyInfo"></CompanyInfo>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import ContactUs from "../components/ContactUs.vue";
import CompanyInfo from "../components/CompanyInfo.vue";
export default {
  name: "NewsDetails",
  components: {
    Banner,
    ContactUs,
    CompanyInfo
  },
  data() {
    return {
      cases: {},
      id: 0,
      caseList:[]
    };
  },
  created() {
    // 这里可以添加根据获取到的item信息进一步请求详细数据的逻辑，比如：
    // this.fetchFullNewsDetails(this.item.id);
    this.id = this.$route.params.cas;
    this.getLoad()
  },
  mounted() {
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.cas !== from.query.cas) {
        this.id = to.query.cas; // 更新 id
        this.getLoad(); // 重新加载数据
    }
    next(); // 继续导航
  },
  methods: {
    contactNow(){
      this.$refs.contactUs.showDialogVisible()
    },
    routeLink(row) {
      this.$router.replace({ 
        name: "casedetails", 
        query: { cas: row } // 使用 query 参数传递新的 id
      });
    },
    scrollDown() {
      // 向下滚动 100 像素
      window.scrollBy({
        top: 1000, // 向下滚动的像素值
        behavior: 'smooth' // 平滑滚动
      });
    },
    getLoad(){
      this.$http
      .get(`case/get?id=${this.id}`)
      .then(response => {
        this.cases={}
        this.cases=response.data.data
        let list=[]
        for(let src of this.cases.fileUrls.split(",")){
          list.push(this.imgserver+src)
        }
        this.cases.fileUrls=list
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });


      this.$http
      .get(`case/page?pageNo=1&pageSize=3`)
      .then(response => {
          this.caseList=[]
          this.caseList = response.data.data.list;
          for (let obj of this.caseList) {
              obj.fileUrls = this.imgserver + obj.fileUrls.split(",")[0];
          }
      })
      .catch(function(error) {
          window.console.log(error);
      });
    },
    showCompanyInfo() {
      this.$refs.companyInfo.showDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));

  &-product {
    width: 80vw;
    margin: 2vw auto;
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.7);
    border-radius: 20px;
    box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.18);
    animation: fadeInProduct 0.6s ease both;
    padding: 2vw;

    &-content {
      width: 90%;
      margin: 0 auto;
      animation: fadeIn 0.5s ease forwards;

      .business-msg {
        width: 100%;
        padding: 2vw 0;
        margin-bottom: 2vw;
        
        .msg-img {
          transition: all 0.4s ease;
          max-height: 20vw;
          object-fit: contain;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          
          &:hover {
            transform: scale(1.03);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          }
        }

        h1 {
          font-size: 2.2vw;
          color: #2c3e50;
          margin-bottom: 1.5vw;
          font-weight: 600;
        }

        .button {
          display: flex;
          gap: 1vw;
          
          .el-button {
            transition: all 0.3s ease;
            padding: 12px 25px;
            font-weight: 500;
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            }
          }
        }
      }

      .slip-text {
        width: 100%;
        margin-bottom: 2vw;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        
        .slip {
          width: 100%;
          height: 3.5vw;
          background: rgba(245, 245, 245, 0.8);
          border-radius: 12px 12px 0 0;
          animation: slideIn 0.5s ease;
          display: flex;
          align-items: center;

          .slip-detail {
            font-size: 1.3vw;
            color: #3388ff;
            padding: 0.5vw 1.5vw;
            border-top: 3px solid #3388ff;
            background-color: white;
            border-radius: 8px 8px 0 0;
            font-weight: 500;
            transition: all 0.3s ease;

            &:hover {
              background-color: #f8f9fa;
            }
          }
        }

        .text-content {
          padding: 2vw;
          white-space: pre-wrap;
          line-height: 2.2vw;
          /* text-indent: 2.5vw;
          letter-spacing: 0.05em;
          line-height: 1.8;
          color: #2c3e50;
          font-size: 1.1vw; */

          :deep(.ql-size-small) {
            font-size: 0.75em;
          }
          
          :deep(.ql-size-large) {
            font-size: 1.5em;
          }
          
          :deep(.ql-size-huge) {
            font-size: 2.5em;
          }
        }
      }

      .img {
        width: 100%;
        margin: 2vw 0;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

        .el-carousel__item {
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            transition: all 0.4s ease;
          }
        }
      }

      .product-title {
        font-size: 2vw;
        color: #2c3e50;
        margin: 2vw 0;
        font-weight: 600;
        text-align: center;
      }

      .product-content {
        padding: 0 2vw;
        white-space: pre-wrap;
        /* font-size: 1.1vw;
        line-height: 1.8;
        color: #2c3e50;
        text-align: justify; */

        :deep(.ql-size-small) {
          font-size: 0.75em;
        }
        
        :deep(.ql-size-large) {
          font-size: 1.5em;
        }
        
        :deep(.ql-size-huge) {
          font-size: 2.5em;
        }
      }
    }
  }
}

.arrow-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 90%;
  margin: 2vw auto;
  cursor: pointer;

  .label {
    font-size: 1.8vw;
    color: #2c3e50;
    font-weight: 500;
  }

  .arrow {
    margin-left: 1vw;
    border-top: 15px solid #3388ff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    animation: bounce 0.5s infinite alternate;
  }
}

.content-modular-item {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2vw;
  padding: 2vw 0;

  .item-list {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    animation: fadeInUp 0.5s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      background: rgba(179, 229, 252, 0.9);

      .item-list-title {
        color: #2c3e50;
      }
    }

    .item-img {
      width: 100%;
      height: 200px;
      background-size: cover;
      background-position: center;
      transition: all 0.4s ease;
    }

    .item-list-title {
      padding: 1vw;
      font-size: 1.1vw;
      color: #2c3e50;
      text-align: center;
      transition: all 0.3s ease;
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(5px);
  }
}

@media screen and (max-width: 768px) {
  .NewsDetails-product {
    width: 95vw;
    padding: 4vw;

    &-content {
      width: 100%;

      .business-msg {
        h1 {
          font-size: 4vw;
        }

        .msg-img {
          max-height: 40vw;
        }
      }

      .slip-text {
        .slip-detail {
          font-size: 3vw;
        }

        .text-content {
          font-size: 3vw;
        }
      }
    }
  }

  .content-modular-item {
    grid-template-columns: 1fr;

    .item-list {
      .item-list-title {
        font-size: 3vw;
      }
    }
  }

  .arrow-container .label {
    font-size: 4vw;
  }
}
</style>